var _defs, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCallHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .call-history-class-a {\n                fill: #fff;\n                fill-rule: evenodd;\n            }\n\n            .call-history-class-b {\n                fill: none !important;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5640.5 5480.774)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "call-history-class-a",
    d: "M5.833,4h5.058a1.833,1.833,0,0,1,1.833,1.83,11.381,11.381,0,0,0,.767,4.088,1.833,1.833,0,0,1-.685,2.181l-.794.534.158.274a13.982,13.982,0,0,0,4.758,4.822l.282.168.565-.8a1.833,1.833,0,0,1,2.04-.693l.14.05a11.385,11.385,0,0,0,4.214.819A1.833,1.833,0,0,1,26,19.108v5.058A1.833,1.833,0,0,1,24.166,26,20.166,20.166,0,0,1,4,5.833,1.833,1.833,0,0,1,5.833,4Zm5.808,6.2a13.214,13.214,0,0,1-.75-4.366H5.833l0,.316A18.333,18.333,0,0,0,24.166,24.167V19.108l-.419-.008a13.219,13.219,0,0,1-4.474-.943L17.8,20.249l-.351-.161a15.814,15.814,0,0,1-7.779-8.08l2.117-1.428Z",
    transform: "translate(-5639 -5479.274)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "call-history-class-b",
    width: 32,
    height: 32
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCallHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_call_history.0457ade16336e10ebacb837b9029115e.svg";